import { Link } from "react-router-dom";
import { Coins, ArrowRight } from "lucide-react";

export const SellBanner = ({ testid = "sell-banner", className = "" }) => (
  <section className={`mx-auto max-w-[1440px] px-4 sm:px-6 lg:px-12 ${className}`} data-testid={testid}>
    <div className="sticker flex flex-col gap-5 rounded-3xl bg-violet-500 p-7 text-white md:flex-row md:items-center md:justify-between md:p-10">
      <div className="flex items-start gap-4">
        <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl border-2 border-black bg-amber-400"><Coins className="h-6 w-6 text-black" /></span>
        <div>
          <p className="font-display text-2xl font-bold">Vendi le tue carte</p>
          <p className="mt-1 max-w-xl text-sm text-white/85">Portale in negozio: il nostro staff le valuta sul momento. Contanti al 30% della proposta o credito negozio al 100%.</p>
        </div>
      </div>
      <Link to="/vendi" className="sticker-btn inline-flex shrink-0 items-center gap-2 self-start rounded-full bg-white px-6 py-3 font-display font-bold text-black md:self-auto" data-testid={`${testid}-link`}>
        Scopri come funziona<ArrowRight className="h-4 w-4" />
      </Link>
    </div>
  </section>
);
